'use client';
import { DialogActionsStyled } from './dialog-actions.styles';

const DialogActions = DialogActionsStyled;

export default DialogActions;
